module.exports = __webpack_public_path__ + "img/logo_stacked.4e1b1fde.svg";